export default __webpack_public_path__ + "static/media/tabler-icon-trash.5bdfd996.svg";